import React, {useMemo} from "react";
import {Table} from "antd";
import "../../event/order-information-card.css";
import {generateTableContent} from "../tableUtils.jsx";

export const BidPackageDetails = ({bidInfo}) => {
    const tableContent = useMemo(() => generateTableContent(bidInfo), [bidInfo]);

    return (
        <>
            <Table
                className="order-information-card-details-table"
                columns={tableContent?.columns}
                dataSource={tableContent?.dataSource}
                summary={tableContent.summary}
                pagination={{position: [], pageSize: tableContent?.dataSource?.length}}
            />
        </>
    );
};
